// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import { createSubscriber, createHook, type HookReturnValue } from '@atlassian/react-sweet-state';
import type { State } from '../model/types.tsx';
import Store from '../store.tsx';
import type { Actions } from '../types.tsx';

export const useHelpPanel = createHook(Store);

export const useHelpPanelActions = createHook(Store, {
	selector: null,
});

export type UseHelpPanelType = () => HookReturnValue<State, Actions>;

export const HelpPanelSubscriber = createSubscriber<State, Actions>(Store, {
	displayName: 'HelpPanelSubscriber',
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const HelpPanelActionsSubscriber = createSubscriber<State, Actions, null, Record<any, any>>(
	Store,
	{
		displayName: 'HelpPanelActionsSubscriber',
		selector: null,
	},
);
